import { render, staticRenderFns } from "./Podio.vue?vue&type=template&id=fd24e4fc&scoped=true&lang=pug&"
import script from "./Podio.vue?vue&type=script&lang=js&"
export * from "./Podio.vue?vue&type=script&lang=js&"
import style0 from "./Podio.vue?vue&type=style&index=0&id=fd24e4fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd24e4fc",
  null
  
)

export default component.exports